<template>
  <div class="page">
    <img src="https://oss.turingsenseai.com/1757499398253376653.jpg" class="logo">
    <template v-if="isResult">
      <template v-if="result == 5">
        <span class="_ii title">Insufficient Images</span>
      </template>
      <template v-else>
        <img :src="getResultImage(true)" class="res">
      </template>
    </template>
    <template v-else>
      <span class="_ii">Under appraisal...</span>
    </template>
    

    <!-- 老版本 -->
    <template v-if="isOldVersion">
      <div class="info">
       <van-image :src="exampleImage" :show-loading="false" fit="contain" class="pic"></van-image>
       <div class="detail">
         <span class="common">{{ detail.kindName ? detail.kindName : "-"}}{{ detail.brandName ? `｜${detail.brandName}`:"" }}{{ detail.seriesName ? `｜${detail.seriesName}`:"" }}</span>
          <span class="common" @click="copyCode(code)">
            SeriesNum: 
            <span class="cc">{{ code || "-" }}</span>
            <img src="https://oss.turingsenseai.com/1757321228317067728.jpg" class="cp">
          </span>
         <span class="common" @click="copyCode(detail.OAID)">
           Case Code: 
           <span class="cc">{{ detail.OAID || "-" }}</span>
           <img src="https://oss.turingsenseai.com/1757321228317067728.jpg" class="cp">
         </span>
         <span class="common">Order Information: {{ detail.sheetId || "-" }}</span>
         <!-- <span class="common">SKU: {{ detail.sku || "-" }}</span> -->
       </div>
      </div>

      <div class="info2">
       <template v-if="isResult">
          <template v-if="result == 5">
            <span class="_li">Insufficient Images</span>
          </template>
          <template v-else>
            <img :src="getResultImage(false)" class="res">
          </template>
       </template>
       <template v-else>
         <span class="_ii blue">Under appraisal...</span>
       </template>

       <div class="images">
         <div class="image" :class="{check: i.image === curr.image}" v-for="(i, index) in detail.SARecordList" @click="checkPoint(detail.SARecordList, index)" :key="i.image">
           <van-image :src="i.image" class="pic" :show-loading="false" fit="contain"></van-image>
           <img src="https://oss.turingsenseai.com/1757325100397942751.jpg" class="fd" @click="previewImage(detail.SARecordList, index)">
           <!-- <div class="name">{{ fuckmap[i.pointName] || "-" }}</div> -->
           <div class="name">{{ i.pointName ? i.pointName : "-" }}</div>
         </div>
       </div>
       <!-- <div class="scord" v-if="curr && curr.grade && gradeProcess(curr.grade) !== 'NaN'">
         <div class="bar">
           <span class="ps" :style="{left: `${gradeProcess(curr.grade)}%`}">{{ gradeProcess(curr.grade) }}points</span>
           <div class="wb" :style="{left: `${gradeProcess(curr.grade)}%`}"></div>
         </div>
         <div class="points">
           <span class="p">0points</span>
           <span class="p">100points</span>
         </div>
       </div> -->
      </div>
    </template>

    <!-- 新版本阿里AE用 -->
    <template v-else>
      <div class="info">
        <van-image :src="exampleImage" :show-loading="false" fit="contain" class="pic"></van-image>
            
        <div class="detail">
          <span class="common">{{ detail.kindEName ? detail.kindEName : "-"}}{{ detail.brandEName ? `｜${detail.brandEName}`:"" }}</span>
          <span class="common" @click="copyCode(detail.seriesNum)">
            SeriesNum: 
            <span class="cc">{{ detail.seriesNum || "-" }}</span>
            <img src="https://oss.turingsenseai.com/1757321228317067728.jpg" class="cp">
          </span>
          <span class="common" @click="copyCode(detail.oaid)">
            Case Code: 
            <span class="cc">{{ detail.oaid || "-" }}</span>
            <img src="https://oss.turingsenseai.com/1757321228317067728.jpg" class="cp">
          </span>
          <span class="common" @click="copyCode(detail.sheetId)">
            Order Information: 
            <span class="cc">{{ detail.sheetId || "-" }}</span>
            <img src="https://oss.turingsenseai.com/1757321228317067728.jpg" class="cp">
          </span>
          <!-- <span class="common">SKU: {{detail.sku ? detail.sku : '-'}}</span> -->
        </div>
      </div>

      <div class="info2">
       <template v-if="isResult">
          <template v-if="result == 5">
            <span class="_li">Insufficient Images</span>
          </template>
          <template v-else>
            <img :src="getResultImage(false)" class="res">
          </template>
       </template>

        <div class="images">
          <div class="image" :class="{check: i.imageUrl === curr.imageUrl}" v-for="(i, index) in detail.singleRecords" @click="checkPoint(detail.singleRecords, index)" :key="i.imageUrl">
            <van-image :src="i.imageUrl" class="pic" :show-loading="false" fit="contain"></van-image>
            <img src="https://oss.turingsenseai.com/1757325100397942751.jpg" class="fd" @click="previewImage(detail.singleRecords, index)">
            <!-- <div class="name">{{ fuckmap[i.pointName] || "-" }}</div> -->
            <div class="name">{{ i.pointEName ? i.pointEName : "-" }}</div>
          </div>
        </div>
        <!-- <div class="scord" v-if="curr && curr.grade && gradeProcess(curr.grade) !== 'NaN'">
          <div class="bar">
            <span class="ps" :style="{left: `${gradeProcess(curr.grade)}%`}">{{ gradeProcess(curr.grade) }}points</span>
            <div class="wb" :style="{left: `${gradeProcess(curr.grade)}%`}"></div>
          </div>
          <div class="points">
            <span class="p">0points</span>
            <span class="p">100points</span>
          </div>
        </div> -->
      </div>
    </template>

     <!-- <div class="rfy">
      <span class="name">Recommended for you</span>
      <div class="images">
        <div class="i" v-for="i in imagesArr" :key="i">
          <img :src="i" class="pic">
          <img src="https://oss.turingsenseai.com/1757588320141982533.jpg" class="icon">
        </div>
      </div>
     </div> -->
    <template v-if="isResult">
      <span class="one">{{ getResultText() }}</span>
    </template>
    <template v-else>
      <span class="one">Under appraisal...</span>
    </template>
    <div class="contact">Contact Email: {{ reportContactEmail }}</div>
     <!-- <span class="two">ALiExpress Collaborative Authentication Service Provider</span> -->
  </div>
  <!-- <div class="no-result" v-else>
    <div class="empty">
      <img class="null-img" src="https://oss.turingsenseai.com/1722581182806982453.jpg">
      <span style="text-align: center;color: gray;">The result is expected to be available within 4 to 24 hours. Please wait patiently~</span>
    </div>
  </div> -->
</template>

<script>
import { Toast, ImagePreview } from 'vant'
import { fetchAliAppraisalReportList } from "@/common/api/ali-appraisal.js"
import { REPORT_CONTACT_EMAIL } from "@/common/constant"
import {
  fetchAppraisalReportDetailV2
} from "@/common/api/appraisal.js";

const fuckmap = {
  "外观":"Appearance",
  "鞋标": "Label under Tounge",
  "走线": "Stitching",
  "背胶": "Gum backing",
  "鞋盒侧标": "Label on Box",
  "鞋盒钢印": "embossed stamp",
  "鞋靴": "Sneakers",
  "全系列": "All Series"
}

const imagesArr = [
  "https://oss.turingsenseai.com/1757588320211024261.jpg",
  "https://oss.turingsenseai.com/1757588320193925091.jpg",
  "https://oss.turingsenseai.com/1757588320193110032.jpg",
  "https://oss.turingsenseai.com/1645856491705378457.png"
]

const aliResult = {
  0: "",
  1: "https://oss.turingsenseai.com/1757401677193715138.jpg",
  2: "https://oss.turingsenseai.com/1757401577606913789.jpg",
  3: "https://oss.turingsenseai.com/1757401758685672443.jpg",
  5: "https://oss.turingsenseai.com/1757580773545900571.jpg"
}

const _aliResult = {
  0: "",
  1: "https://oss.turingsenseai.com/1757320608953400642.jpg",
  2: "https://oss.turingsenseai.com/1757401650181389158.jpg",
  3: "https://oss.turingsenseai.com/1757401753109406966.jpg",
  5: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

const aliImages = {
  0: "",
  1: "https://oss.turingsenseai.com/1757401677193715138.jpg",
  2: "https://oss.turingsenseai.com/1757401577606913789.jpg",
  3: "https://oss.turingsenseai.com/1757401758685672443.jpg",
  5: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

const _aliImages = {
  0: "",
  1: "https://oss.turingsenseai.com/1757320608953400642.jpg",
  2: "https://oss.turingsenseai.com/1757401650181389158.jpg",
  3: "https://oss.turingsenseai.com/1757401753109406966.jpg",
  5: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

const aliText = {
  0: "Under appraisal...",
  1: "Authentic Item Verified",
  2: "Counterfeit Item Verified",
  3: "Inconclusive Item Verified",
  5: "Insufficient Images",
}

const result = {
  0: "https://oss.turingsenseai.com/1757401577606913789.jpg",
  1: "https://oss.turingsenseai.com/1757401677193715138.jpg",
  2: "https://oss.turingsenseai.com/1757401758685672443.jpg",
  3: "https://oss.turingsenseai.com/1757580773545900571.jpg"
}

const _result = {
  0: "https://oss.turingsenseai.com/1757401650181389158.jpg",
  1: "https://oss.turingsenseai.com/1757320608953400642.jpg",
  2: "https://oss.turingsenseai.com/1757401753109406966.jpg",
  3: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

const aitom = {
  0: "",
  1: "https://oss.turingsenseai.com/1757401677193715138.jpg",
  2: "https://oss.turingsenseai.com/1757401577606913789.jpg",
  3: "https://oss.turingsenseai.com/1757401758685672443.jpg",
}

const _aitom = {
  0: "",
  1: "https://oss.turingsenseai.com/1757320608953400642.jpg",
  2: "https://oss.turingsenseai.com/1757401650181389158.jpg",
  3: "https://oss.turingsenseai.com/1757401753109406966.jpg",
}

const aitomText = {
  0: "Under appraisal...",
  1: "Authentic Item Verified",
  2: "Counterfeit Item Verified",
  3: "Inconclusive Item Verified",
}

const resultText = {
  0: "Counterfeit Item Verified",
  1: "Authentic Item Verified",
  2: "Inconclusive Item Verified",
  3: "Insufficient Images",
}

function generateRandomDigits() {
  let result = '';
  for (let i = 0; i < 10; i++) {
    result += Math.floor(Math.random() * 10);
  }
  return result;
}

export default {
  name: 'aliintl',
  data() {
    return {
      detail: {},
      isResult: false,
      exampleImage: "",
      curr: "",
      result: "",
      imagesArr,
      fuckmap,
      isOldVersion: false,
      code: "",
      reportContactEmail: REPORT_CONTACT_EMAIL,
    };
  },
  computed: {
    code1: ()=>generateRandomDigits(),
    code2: ()=>generateRandomDigits(),
  },
  created(){
    const {code=""} = this.$route.params;
    this.code = code
    this.getReport(code)
  },
  methods: {
    copyCode(id){
      this.$copyText(id).then(res => {
        Toast.success('Copied')
      })
    },
    gradeProcess(grade){
      if(this.detail.isManual){
        return Number(grade)
      }
      return (Number(grade)*100).toFixed(0)
    },
    getResultImage( outside = true){
      if(outside){
        return this.isOldVersion ? (this.detail.aIToManualResult ? _aitom[this.result] : _result[this.result]) : (this.detail.appraisalResult ? _aliImages[this.result] : _aliResult[this.result])
      }
      return this.isOldVersion ? (this.detail.aIToManualResult ? aitom[this.result] : result[this.result]) : (this.detail.appraisalResult ? aliImages[this.result] : aliResult[this.result])
    },
    getResultText(){
      return this.isOldVersion ? (this.detail.aIToManualResult ? aitomText[this.result] : resultText[this.result]) : aliText[this.result]
    },
    getReport(code) {
      console.log('报告号',code)
      fetchAliAppraisalReportList({
        seriesNum: code
      }).then(res => {
        if(res.errCode == 10065){
          this.isOldVersion = true
          fetchAppraisalReportDetailV2({
            serialNum: code
          }).then(res => {
            if(res.errorMsg == "Success"){
              this.detail = res
              this.result = res.aIToManualResult || res.genuine
              this.exampleImage = res.SARecordList[0].image
              this.curr = res.SARecordList[0] || null
              if((res.aIToManualResult || res.isManual) && this.getResultImage()){
                this.isResult = true
              }
            }
          })
        }else if(res.errMsg == "Success"){
          this.isOldVersion = false
          this.detail = res
          this.result = res.appraisalResult
          this.exampleImage = res.singleRecords[0].imageUrl
          this.curr = res.singleRecords[0] || null
          if((res.appraisalResult) && this.getResultImage()){
            this.isResult = true
          }
        }
      })
    },
    previewImage(points, index){
      ImagePreview({
        images: this.isOldVersion ? points.map(i => i.image) : points.map(i => i.imageUrl),
        startPosition: index,
      });
    },
    checkPoint(points, index){
      this.curr = points[index]
    }
  } 
};
</script>

<style lang="scss" scoped> 
.rfy{
  background-color: #fff;
  border-radius: 32px;
  box-sizing: border-box;
  padding: 24px;
  width: 100%;
  margin-top: 24px;

  .name{
    color: #2A2A30;
    font-weight: 28px;
    font-weight: 600;
  }

  .images{
    display: flex;
    overflow-x: scroll;
    margin-top: 16px;
    width: 100%;
    height: 180px;

    .i{
      width: 180px;
      height: 180px;
      border-radius: 16px;
      position: relative;
      flex-shrink: 0;

      &:not(:last-child){
        margin-right: 16px;
      }

      .pic{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .icon{
        position: absolute;
        width: 30px;
        height: 30px;
        bottom: 10px;
        right: 10px;
      }
    }
  }
}
.check{
  outline: 4px solid #3B95FF;

  .name{
    background-color: #3B95FF !important;
  }
}
.logo{
  height: 32px;
  margin-bottom: 52px;
  object-fit: contain ;
}
.page{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FF2751;
  box-sizing: border-box;
  padding: 32px 32px 180px;

  .res{
    object-fit: contain;
    height: 86px;
  }

  .info{
    background-color: #fff;
    width: 100%;
    margin-top: 32px;
    border-radius: 32px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;

    .pic{
      width: 99*2px;
      height: 99*2px;
      object-fit: cover;
      border-radius: 16px;
      background-color: rgba(128, 128, 128, 0.221);
      margin-right: 24px;
      overflow: hidden;
    }

    .detail{
      display: flex;
      flex-direction: column;
      justify-content: center;

      .name{
        font-size: 26px;
        margin-bottom: 12px;
        font-weight: 500;
      }

      .common{
        color: #77767E;
        font-size: 24px;
        font-weight: 300;

        &:not(:last-child){
          margin-bottom: 12px;
        }

        .cc{
          color: #3C78F0;
          font-weight: 400;
        }

        .cp{
          width: 24px;
          height: 24px;
          object-fit: contain;
          margin-left: 10px;
          margin-bottom: 4px;
        }
      }
    }
  }

  .info2{
    background-color: #fff;
    width: 343*2px;
    margin-top: 32px;
    border-radius: 32px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: start;
    flex-direction: column;

    .res{
      object-fit: contain;
      height: 86px;
      margin-bottom: 16px;
    }

    .images{
      width: 319*2px;
      // display: flex;
      // flex-wrap: wrap;
      // overflow-x: scroll;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;

      .image{
        height: 200px;
        width: 200px;
        // width: 100%;
        // height: 100%;
        flex-shrink: 0;
        overflow: hidden;
        border-radius: 16px;
        position: relative;
        border: 1px solid #E5E5E5;

        &:not(:last-child){
          margin-right: 16px;
        }

        .fd{
          position: absolute;
          object-fit: contain;
          width: 30px;
          height: 30px;
          right: 10px;
          bottom: 10px;
        }

        .name{
          background-color: #0C0C0C;
          max-width: 100%;
          padding: 4px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 20px;
          font-weight: 400;
          border-radius: 0 0 16px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .pic{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .scord{
      margin-top: 44px;
      display: flex;
      flex-direction: column;
      width: 100%;

      .bar{
        position: relative;
        width: 100%;
        height: 12px;
        border-radius: 6px;
        background: linear-gradient(270.02deg, #3971F6 0.75%, #77D6F6 100.54%);

        .ps{
          color: #77767E;
          font-size: 24px;
          font-weight: 400;
          position: absolute;
          bottom: 12px;
          transform: translateX(-50%);
          margin-bottom: 2px;
          transition: all 0.3s linear;
        }

        .wb{
          height: 100%;
          width: 8px;
          background-color: #fff;
          position: absolute;
          transition: all 0.3s linear;
        }
      }

      .points{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .p{
          color: #828393;
          font-size: 22px;
          font-weight: 400;
          margin-top: 4px;
        }
      }
    }
  }

  .one{
    color: #FFFFFF;
    font-size: 32px;
    font-weight: 600;
    margin-top: 24px;
  }

  .contact{
    margin-top: 12px;
    text-align: center;
    color: #FFFFFF;
    font-size: 20px;
    line-height: 28px;
    word-break: break-word;
  }

  .two{
    color: #FFE0E0;
    font-size: 20px;
    font-weight: 400;
    margin-top: 10px;
  }
}
.no-result {
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .empty {
    margin-top: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
  }

  .null-img {
    width: 300px;
    object-fit: contain;
  }
}
._ii{
  color: #fff;
  font-weight: 600;
  font-size: 40px;
}
.title{
  font-size: 55px;
}
._li{
  color: #1e9fff;
  font-weight: 600;
  font-size: 40px;
  margin-bottom: 20px;
}
.blue{
  color: #1e9fff;
  margin-bottom: 20px;
}
</style>
